export default __webpack_public_path__ + "static/spiritual-india-people-1-b8f6eea20bf32e47bca67988b721e704.jpg";